// Single place that knows where the access token lives, so the interceptors,
// the login screens and the route guard cannot drift apart.

const TOKEN_KEY = "accessToken";

export const setAccessToken = (token) => {
  if (!token) return;
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch (error) {
    // Private browsing modes can refuse to write; the session simply will not
    // survive a reload.
    console.warn("Could not store the access token:", error);
  }
};

export const getAccessToken = () => {
  try {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token || token === "undefined" || token === "null") return null;
    return token;
  } catch (error) {
    return null;
  }
};

export const clearAccessToken = () => {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch (error) {
    /* nothing useful to do */
  }
};

export const isLoggedIn = () => getAccessToken() !== null;

// Candidates and employers return to different login screens.
export const loginPathForCurrentUser = () => {
  try {
    return localStorage.getItem("candidateId")
      ? "/candidateLogin"
      : "/employerLogin";
  } catch (error) {
    return "/employerLogin";
  }
};

// Wipes the session and sends the user back to the right login screen. Guarded
// so that several failing requests at once cannot cause a redirect loop.
let redirecting = false;

export const endSessionAndRedirect = () => {
  if (redirecting) return;
  redirecting = true;

  const target = loginPathForCurrentUser();
  try {
    localStorage.clear();
  } catch (error) {
    /* nothing useful to do */
  }
  window.location.href = target;
};
